<template>
  <div class="left-chat">
    <div class="left-chat-avatar">
      <img src="/src/assets/logo@2x.png" class="default-header-img" alt="" />
      <!-- <leftChatModal :collapse="isCollapse" />
      <el-popover
        v-if="useUserStore().nickName.length > 6"
        :width="200"
        trigger="hover"
        placement="left"
        :content="useUserStore().nickName"
      >
        <template #reference>
          <div class="user-nick-name" :style="isCollapse ? 'max-width:3.3vw' : 'max-width:6vw'">
            {{ useUserStore().nickName }}
          </div>
        </template>
      </el-popover>
      <div class="user-nick-name" :style="isCollapse ? 'max-width:3.3vw' : 'max-width:5vw'" v-else>
        {{ useUserStore().nickName }}
      </div> -->
    </div>

    <!-- <span style="color: white"> {{ sliderStore.sliderData }}</span> -->
    <!-- <div class="toggleBtn" @click="toggleCollapse">
      <el-icon size="20" color="#F1F5FF">
        <Expand v-if="isCollapse" />
        <Fold v-else />
      </el-icon>
    </div> -->
    <!-- !isCollapse ? 'el-menu-vertical-demo' : 'el-menu-vertical-demo collapse-menu' -->
    <el-menu
      :class="{
        'el-menu-vertical-demo': true,
        'collapse-menu': isCollapse,
        'nomenu-txt': useUserStore().locale == 'zh-cn'
      }"
      @open="_handleOpen"
      @close="_handleClose"
      :collapse="isCollapse"
      background-color="#334C8D"
      :router="state.isOpenRouter"
      text-color="#78C6FF"
      :default-active="activeMenu"
      @select="handleMenuSelect"
      active-text-color="#F1F5FF"
    >
      <MenuItem
        v-for="(item, index) in sliderStore.sliderData"
        :key="item.path"
        :item="item"
        :index="index"
        :isCollapse="isCollapse"
        :activeMenu="activeMenu"
        :tooltip="tooltip"
        :isTooltipVisible="isTooltipVisible"
        :hasSuperviseInfo="hasSuperviseInfo"
        :hasOrderInfo="hasOrderInfo"
      />
      <!-- <el-menu-item
        v-for="item in sliderStore.sliderData"
        :index="item.path"
        class="left-chat-menu"
      >
        <el-badge
          :value="
            item.path == '/customer'
              ? chatListStore.unReadNumber > 0
                ? chatListStore.unReadNumber
                : ''
              : ''
          "
          class="badge-style"
          type="danger"
        >
        </el-badge>
        <el-popover
          :width="200"
          trigger="hover"
          :visible="item.name == tooltip && isCollapse && !isTooltipVisible"
          :content="$t(item.name)"
        >
          <template #reference>
            <div
              v-html="item.icon"
              :class="{ 'red-dot': hasSuperviseInfo && item.name == 'check_manage' }"
              style="
                width: 24px;
                height: 24px;
                font-size: 24px;
                color: #c2c6ce;
                margin-right: 0.55rem;
              "
              v-if="!item.isActive"
              @mouseenter="showTooltip(item.name)"
              @mouseleave="hideTooltip"
            ></div>
            <div
              v-html="item.activeIcon"
              :class="{ 'red-dot': hasSuperviseInfo && item.name == 'check_manage' }"
              style="
                font-size: 24px;
                width: 24px;
                height: 24px;
                color: #c2c6ce;
                margin-right: 0.55rem;
              "
              v-else-if="item.isActive"
              @mouseenter="showTooltip(item.name)"
              @mouseleave="hideTooltip"
            ></div>
           
          </template>
        </el-popover>
        <template #title>{{ $t(item.name) }}</template>
      </el-menu-item> -->
      <!-- <iconpark-icon
              :name="item.icon"
              style="font-size: 24px; color: #c2c6ce;margin-right: 0.55rem;"
              v-if="!item.isActive"
              @mouseenter="showTooltip(item.name)"
              @mouseleave="hideTooltip"
            >
            </iconpark-icon>
            <iconpark-icon
              :name="item.activeIcon"
              style="font-size: 24px; color: #1977fd;margin-right: 0.55rem;"
              v-if="item.isActive"
              @mouseenter="showTooltip(item.name)"
              @mouseleave="hideTooltip"
            ></iconpark-icon> -->
    </el-menu>

    <div
      @click="setting"
      v-if="isAuth('im:settingother')"
      class="bottom-icon hidden-md-and-down"
      style="cursor: pointer; height: 60px"
    >
      <div class="setting-box">
        <!-- <iconpark-icon
        name="setting-two"
        style="font-size: 24px"
      ></iconpark-icon> -->
        <img
          src="@/assets/icons/setting-c.png"
          style="width: 24px; height: 24px"
          v-if="!settingIconFlag"
        />
        <img src="@/assets/icons/setting-u.png" style="width: 24px; height: 24px" v-else />

        <!-- <iconpark-icon
        name="setting-two-aa0g18e8"
        style="font-size: 24px"
        v-if="settingIconFlag"
      ></iconpark-icon> -->
        <!-- <span v-if="!isCollapse" style="color: #78C6FF;">{{ $t('SETTING.set_up') }}</span> -->
        <span :style="{ color: isSettingClicked ? 'white' : '#78C6FF' }" v-if="!isCollapse">{{
          $t('SETTING.set_up')
        }}</span>
      </div>
    </div>

    <!-- <i class="iconfont">&#xe761;</i> -->
    <!-- 设置 -->
  </div>
</template>

<script lang="ts" setup>
import { reactive, watchEffect, ref, onMounted, watch, defineExpose, getCurrentInstance } from 'vue'
import leftChatModal from './left-chat-modal.vue'
import { useSliderStore, useChatListStore, useUserStore, useWebSocketStore } from '@/stores'
import { useRouter, useRoute } from 'vue-router'
import MenuItem from './menu-item/index.vue'
import { setupRoutes } from '@/router'
import { isAuth } from '@/utils/permission/permission-auth'
const webSocketStore = useWebSocketStore()
const sliderStore = useSliderStore()
const chatListStore = useChatListStore()
const isCollapse = ref(true)
const router = useRouter()
const route = useRoute()
const tooltip = ref('')

const { $t } = getCurrentInstance()?.appContext.config.globalProperties || {}
const state = reactive({
  isShow: false,
  //是否开启菜单路由
  isOpenRouter: true
})
const settingIconFlag = ref(false)
const isSettingClicked = ref(false)
const setting = () => {
  router.push('/system/setting')
}
const isTooltipVisible = ref(false)
const showTooltip = (name: string) => {
  if (tooltip.value !== name) {
    tooltip.value = name
    isTooltipVisible.value = true
  }
}

const hideTooltip = () => {
  tooltip.value = ''
  isTooltipVisible.value = false
}
const activeMenu = ref('')
const activeMenuName = ref()
const handleMenuSelect = (index: any) => {
  console.log(index, 'handleMenuSelect')
  activeMenu.value = index
  // this.activeSubMenu = index.includes('-') ? index : '';
  // getMenuName(index)
  console.log(route.meta.languageKey, 'route.path')
  // sliderStore.setNavTitle($t(route.meta?.languageKey ?? ''))
}
const getMenuName = (index: any) => {
  if (index) {
    console.log(sliderStore.sliderData, 'sliderStore.sliderData')
    sliderStore.sliderData.forEach((i, idx) => {
      if (i.path == index) {
        activeMenuName.value = i.name
      }
    })
    sliderStore.setNavTitle(activeMenuName.value)
  }

  // localStorage.setItem('navTitle', $t(activeMenuName.value))
}
// let routerpath = JSON.parse(localStorage.getItem('routerpath'))?.to
// onMounted(async () => {
//   await setupRoutes()
//   debugger
//   if (routerpath.path) {
//     useRouter().push(routerpath.path)
//   } else {
//     useRouter().push('/home')
//   }
// })
// 监听路由变化

watch(
  () => sliderStore.routerData,
  (newVal) => {
    sliderStore.setSliderData()
  }
)

const hasSuperviseInfo = ref(false)
watch(
  () => webSocketStore.hasSuperviseInfo,
  (newVal, oldVal) => {
    hasSuperviseInfo.value = newVal
  }
)

const hasOrderInfo = ref(false)
watch(
  () => webSocketStore.hasOrderInfo,
  (newVal, oldVal) => {
    hasOrderInfo.value = newVal
  }
)
watch(
  () => isCollapse.value,
  (newVal, oldVal) => {
    sliderStore.setIsCollapse(newVal)
  }
)
onMounted(() => {
  if (!sliderStore.sliderData || sliderStore.sliderData.length == 0) {
    sliderStore.init()
  }
  // 初始化时设置当前路由为激活菜单
  activeMenu.value = route.path
})
const language = ref('')
watch(
  () => useUserStore().locale,
  (newVal, oldVal) => {
    language.value = newVal
  }
)
watchEffect(() => {
  if (route.path == '/system/setting') {
    settingIconFlag.value = true
    isSettingClicked.value = true
    sliderStore.activeItem(route.path)
    activeMenu.value = route.path
    useWebSocketStore().goOutDetailPage()
  } else {
    if (route.path == '/checkNew') {
      useWebSocketStore().closeSuperviseInfo()
      useWebSocketStore().goDetailPage()
    } else if (route.path == '/workorder') {
      useWebSocketStore().closeOrderInfo()
      useWebSocketStore().goOrderDetailPage()
    } else {
      useWebSocketStore().goOutDetailPage()
      useWebSocketStore().goOutOrderDetailPage()
      
    }
    settingIconFlag.value = false
    isSettingClicked.value = false
    sliderStore.activeItem(route.path)
    activeMenu.value = route.path
  }
})

const toggleCollapse = () => {
  isCollapse.value = !isCollapse.value
}
const toggleCollapseMenu = () => {
  isCollapse.value = !isCollapse.value
  return isCollapse.value
}
const _handleClose = () => {}
const _handleOpen = () => {}

defineExpose({ toggleCollapse, toggleCollapseMenu, isCollapse })
</script>
<style lang="scss">
.red-dot {
  color: red;
  position: relative;
}
.red-dot::before {
  width: 8px;
  height: 8px;
  background-color: red;
  content: '';
  display: inline-block;
  border-radius: 50%;
  position: absolute;
  right: -4px;
  top: 0;
}
</style>
<style lang="scss" scoped>
.left-chat {
  display: flex;
  flex-direction: column;
  // align-items: center;
  background: #334c8d;
  box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.08);
  // width: 100%;
  height: 100vh;
  padding-top: 0.5rem;
  // opacity: 0.9;
  position: relative;
  z-index: 1;
  // min-width: 4rem;

  .lc-img {
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
  }
  .toggleBtn {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .el-menu-vertical-demo {
    border: 0 !important;
    // width: 4.5vw;
    display: flex;
    // align-items: center;
    flex-direction: column;
    margin-bottom: 40px;
    overflow-y: auto;
    scrollbar-width: none; /* 滚动条的宽度：auto | thin | none */
    // scrollbar-width: none; /* 隐藏滚动条 */
    // -ms-overflow-style: none; /* 适用于 IE 和 Edge */
  }
  .el-menu-vertical-demo:hover {
    scrollbar-color: rgba(144, 147, 153, 0.6) #334c8d; /* 滚动条颜色 和 滚动条背景色 */
    transition: scrollbar-color 0.3s ease; /* 添加过渡效果 */
    scrollbar-width: thin;
    //  scrollbar-width: none;
  }
  .nomenu-txt {
    display: block !important;
  }
  .collapse-menu:hover {
    scrollbar-width: none !important;
  }
  //这里设置展开
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 12rem;
    min-width: 10rem;
    min-height: 50vh;
    // overflow-y: auto;
    padding-bottom: 30px;
  }
  .el-menu-vertical-demo::-webkit-scrollbar {
    // display: none; /* 隐藏滚动条 */
    width: 0.4rem !important; /* 滚动条宽度 */
  }
  .el-menu-vertical-demo ::-webkit-scrollbar-track {
    background-color: var(--vt-c-white); /* 滚动条轨道背景色 */
  }
  .el-menu-vertical-demo::-webkit-scrollbar-thumb {
    // background-color: rgba(144, 147, 153, 0.6); /* 滚动条颜色 */
    width: 0.4rem;
    background-color: rgba(144, 147, 153, 0.6); /* 滚动条颜色 */
    border-radius: 3px; /* 滚动条圆角 */
  }
  .el-menu-vertical-demo ::-webkit-scrollbar-thumb:hover {
    background-color: #999; /* 滚动条悬停颜色 */
    width: 0.4rem; /* 滚动条宽度 */
  }
  .el-menu-vertical-demo::-moz-scrollbar {
    // display: none; /* 隐藏滚动条 */
    width: 0.4rem; /* 滚动条宽度 */
  }
  .el-menu-vertical-demo::-moz-scrollbar-track {
    background-color: var(--vt-c-white); /* 滚动条轨道背景色 */
  }
  .el-menu-vertical-demo::-moz-scrollbar-thumb {
    // background-color: rgba(144, 147, 153, 0.6); /* 滚动条颜色 */
    background-color: rgba(144, 147, 153, 0.6); /* 滚动条颜色 */
    border-radius: 3px; /* 滚动条圆角 */
  }
  .el-menu-vertical-demo ::-moz-scrollbar-thumb:hover {
    background-color: #999; /* 滚动条悬停颜色 */
    width: 0.4rem; /* 滚动条宽度 */
  }
  .left-chat-avatar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 2.1rem;
    margin-bottom: 0.1rem;
  }
  .left-chat-menu {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    position: relative;

    .badge-style {
      position: absolute;
      left: 1.975rem;
      bottom: 1.6125rem;
      z-index: 99;
    }
  }

  .left-chat-menu:hover {
    background-color: #2a354c;
  }

  .menu-icon {
    font-size: 2.25rem;
  }
  .left-chat-menu:hover .span-text {
    color: #fff;
  }
  .span-text {
    font-size: 14px;
    font-family: Source Han Sans CN-Normal, Source Han Sans CN;
    line-height: 22px;
    margin-left: 5px;
  }
  .bottom-icon {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 8vh;
    display: flex;
    // flex-direction: ;
    padding: 0 var(--el-menu-base-level-padding);
    justify-content: center;
    align-items: center;
    .setting-box {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      width: 100%;
      span {
        color: #78c6ff;
        margin-left: 0.55rem;
      }
    }
  }
  .bottom-icon:hover {
    background-color: #2a354c;
  }
  .bottom-icon:hover #setting-two {
  }
  .user-nick-name {
    color: #f1f5ff;
    font-weight: bold;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
@media (max-width: 768px) {
  .left-chat {
    display: none;
  }
}
// @media screen and (max-width: 992px) {
//   .left-chat {
//     display: flex;
//     // flex-direction: row;
//     // align-items: center;
//     // background-color: var(--xr-main-bg-color);
//     background: linear-gradient( 180deg, #334C8D 0%, #333E5A 100%);
//     box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.08);
//     width: 100%;
//     // height: 100vh;
//     padding: 0.5rem;
//     // opacity: 0.9;
//     // position: relative;
//     z-index: 1;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     // min-width: 4rem;
//     .lc-img {
//       width: 2.5rem;
//       height: 2.5rem;
//       cursor: pointer;
//     }
//     .el-menu-vertical-demo {
//       border: 0 !important;
//       width: 80vw;
//       display: flex;
//       align-items: center;
//       flex-direction: row;
//     }
//     .left-chat-menu {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       position: relative;
//       height: 3rem;
//       width: 3rem;

//       .badge-style {
//         position: absolute;
//         left: 1.975rem;
//         bottom: 1.6125rem;
//         z-index: 99;
//       }
//     }

//     .left-chat-menu:hover {
//       background-color: #2a354c;
//     }

//     .menu-icon {
//       font-size: 2.25rem;
//     }
//     .left-chat-menu:hover .span-text {
//       color: #fff;
//     }
//     .span-text {
//       font-size: 14px;
//       font-family: Source Han Sans CN-Normal, Source Han Sans CN;
//       line-height: 22px;
//       margin-left: 5px;
//     }
//     .bottom-icon {
//       position: absolute;
//       right: 0.5rem;
//       display: flex;
//       align-items: center;
//       // width: 100%;
//       // height: 8vh;
//       // display: flex;
//       // flex-direction: ;
//       // justify-content: center;
//       // align-items: center;
//       // img {
//       //   width: 1.375rem;
//       //   height: 1.5625rem;
//       // }
//     }
//     .bottom-icon:hover {
//       background-color: #2a354c;
//     }
//     .bottom-icon:hover #setting-two {
//     }
//   }
// }
</style>
